<template>
    <div id="archive-information-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Archive Information</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div v-if="claim" class="modal-body">
                    <div class="h5"><span class="font-weight-bold">Claim Number:</span> {{ claim.claim_number }}</div>
                    <div class="h5 mb-2"><span class="font-weight-bold">Patient Name:</span> {{ claim.patient_name }}</div>
                    <div><span class="font-weight-bold">Archived At:</span> {{ claim.archived_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</div>
                    <div><span class="font-weight-bold">Archived By:</span> {{ claim.archived_by }}</div>
                    <div class="font-weight-bold mt-2">
                        Archive Note 
                        <small class="text-muted"><em>(Optional)</em></small>
                        <a href="javascript:void(0)" title="Edit Archive Note" @click="edit = true"><i class="fas fa-pencil-alt fa-xs"></i></a>
                    </div>
                    <textarea v-if="edit" id="archiveNote" class="form-control" v-model="claim.archive_note"></textarea>
                    <div v-else>{{ claim.archive_note }}</div>
                </div>
                <div class="modal-footer">
                    <button v-if="edit" class="btn btn-primary" data-dismiss="modal" @click="save()">Save</button>
                    <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() {
        return {
            claim: null,
            edit: false
        }
    },
    methods: {
        show: function (claim) {
            this.claim = claim;
            this.edit = false;
            $('#archive-information-modal').modal('show');
        },
        save: function () {
            this.$emit('save', this.claim);
        }
    },
    created() {        
        eventHub.$on('show-archive-information', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-archive-information');
    }  
}
</script>